import axios from 'axios'
import create from 'zustand'
import { persist } from 'zustand/middleware'
import Cookies from 'js-cookie'

//#region course store
let store = (set) => ({
  // store courses
  // get All courses
  courses: {},

  courseCount: 0,
  getCourses: async () => {
    // setting token
    let token = Cookies.get('token')

    // attach token to header
    // sort and order data by which column and how
    const config = {
      headers: {
        Authorization: 'Bearer ' + token,
      },
      params: {
        sortBy: 'course.id',
        orderBy: 'desc',
      }
    }
    // setting url 
    // main url comes from .env file
    const apiResponse = await axios.get(`${process.env.REACT_APP_API}/course`, config)
    set(async (state) => {
      // initilize courses state variable to the responsed courses if request succeed
      if (apiResponse?.status == 200 || apiResponse?.status == 201)
        state.courses = apiResponse.data
    })
  },
  getcourseCount: async () => {
    // setting token
    let token = Cookies.get('token')

    // attach token to header
    // sort and order data by which column and how
    const config = {
      headers: {
        Authorization: 'Bearer ' + token,
      }
    }
    // setting url 
    // main url comes from .env file
    const apiResponse = await axios.get(`${process.env.REACT_APP_API}/course/getcount/length`, config)
    set(async (state) => {
      // initilize coursesets state variable to the responsed coursesets if request succeed
      if (apiResponse?.status == 200 || apiResponse?.status == 201) {
        state.courseCount = apiResponse?.data?.course ?? ''
      }
    })
  },
  addCourse: async (payload) => {
    // setting token
    let token = Cookies.get('token')

    // attaching token to the header
    const config = {
      headers: {
        Authorization: 'Bearer ' + token,
      },
    }

    // setting url 
    // main url comes from .env file 
    const apiResponse = await axios.post(`${process.env.REACT_APP_API}/course`, payload, config)
    if (apiResponse?.status === 201) {
      set(async (state) => {
        // initilizing courses state variable to the resoponsed data
        state.courses = {
          data: [apiResponse.data, ...state.courses.data],
          limit: state.courses.limit,
          page: state.courses.page,
          totalCount: state.courses.totalCount + 1,
        }
      })
    }
    return apiResponse
  },
  editCourse: async (payload, id) => {
    // setting token
    let token = Cookies.get('token')

    // attaching token to the header
    const config = {
      headers: {
        Authorization: 'Bearer ' + token,
      },
    }

    // setting url 
    // main url comes from .env file 
    const apiResponse = await axios.patch(`${process.env.REACT_APP_API}/course/${id}`, payload, config)
    // update courses state variable if update request was succeed
    if (apiResponse?.status === 200) {
      set(async (state) => {
        const result = state.courses?.data?.find((course, index) => {

          if (course.id === id) {
            state.courses.data[index] = apiResponse?.data
          }
        })

        state.courses = {
          data: [...state.courses.data],
          limit: state.courses.limit,
          page: state.courses.page,
          totalCount: state.courses.totalCount,
        }
      })
    }
    return apiResponse
  },
  deleteCourse: async (id) => {
    // setting token
    let token = Cookies.get('token')

    // attaching token to the header
    const config = {
      headers: {
        Authorization: 'Bearer ' + token,
      },
    }
    // setting url 
    // main url comes from .env file 
    const apiResponse = await axios.delete(`${process.env.REACT_APP_API}/course/${id}`, config)
    // delete element in the courses.data array state if the request was succeed
    if (apiResponse?.status === 200) {

      set(async (state) => {
        const arr = state.courses.data.filter(item => item.id !== id)
        state.courses = {
          data: arr,
          limit: state.courses.limit,
          page: state.courses.page,
          totalCount: state.courses.totalCount - 1,
        }
      })

    }

    return apiResponse

  },
})
//#endregion course store

// store the state in the browser local storage
// store = persist(store, { name: 'course' })

// getting store data in the browser localstorage
const course_Store = create(store)

export default course_Store
